import { createSlice } from "@reduxjs/toolkit";

export const patientSlice = createSlice({
    name: 'patient',
    initialState: {
        checked: false,
        value: {}
    },
    reducers: {
        setPatientChecked: (state, action) => {
            state.checked = action.payload;
        },
        setPatient: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setPatient, setPatientChecked } = patientSlice.actions;

export const getPatient = (state) => state.patient.value;
export const getPatientChecked = (state) => state.patient.checked;

export default patientSlice.reducer;